import API from "../../classes/Api/Api"; 
import URL from "../../classes/Url/URL";
import Response from "../../classes/Response/Response";
import User from "../../classes/User/User";
import CustomError from "../../classes/CustomError/CustomError";
import Storage from "../../classes/Storage/Storage";

const ProfileService = () => {
  const changePassword = async (userId, passwords) => {
    const api = new API(`${URL.URL_SERVER}/passwords/${userId}`);
    try {
      const http_response = await api.put(passwords);
      const has_error = http_response instanceof CustomError;
      if (has_error) {
        return http_response;
      }
      const response = new Response(http_response, User);
      return response.wasSuccessfull();
    } catch (error) {
      return new CustomError("Error changing password", error);
    }
  };

  const updateData = async (data) => {
    const id = new Storage("id").getItem();
    const api = new API(`${URL.URL_SERVER}/users/${id}`);
    try {
      const response = await api.put(data);

      if (response.status === 204) {
        return true;
      } else if (response.wasSuccessful) {
        return true;
      } else {
        throw new Error("Error in updatedata (profile service)");
      }
    } catch (error) {
      throw error;
    }
  };

  const updateCellphone = async (cellphone) => {
    const id = new Storage("id").getItem();
    const api = new API(`${URL.URL_SERVER}/users/${id}`);

    const body = [
      {
        op: "replace",
        path: "/cellphone",
        value: cellphone,
      },
    ];

    try {
      const http_response = await api.patch(body);
      const has_error = http_response instanceof CustomError;
      if (has_error) return http_response;

      const response = new Response(http_response, User);
      return response;
    } catch (error) {
      return new CustomError("Error updating cellphone", error);
    }
  };

  const getUser = async () => {
    const id = new Storage("id").getItem();
    const api = new API(`${URL.URL_SERVER}/users/${id}`);
    const http_response = await api.get();

    const has_error = http_response instanceof CustomError;
    if (has_error) return http_response;

    const response = new Response(http_response, User);
    return response;
  };

  const updateMFA = async (enabled) => {
    const id = new Storage("id").getItem();
    const api = new API(`${URL.URL_SERVER}/users/${id}`);

    const body = [
      {
        op: "replace",
        path: "/mfa",
        value: enabled,
      },
    ];

    try {
      const http_response = await api.patch(body);
      const has_error = http_response instanceof CustomError;
      if (has_error) return http_response;

      if (http_response.status === 204) {
        return { success: true, status: 204 };
      }

      const response = new Response(http_response, User);
      return response;
    } catch (error) {
      return new CustomError("Error MFA", error);
    }
  };

  return {
    changePassword,
    updateData,
    updateCellphone,
    getUser,
    updateMFA,
  };
};

export default ProfileService;
